var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-account-containter w-100 h-100"},[_c('div',{staticClass:"row no-gutters h-100 w-100"},[_c('div',{staticClass:"col-lg-8"},[_c('div',{staticClass:"sf-account-text hd_head-100_1",domProps:{"innerHTML":_vm._s(_vm.text)}})]),_c('div',{staticClass:"col-lg-4 sf-account-right"},[_c('login-form')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }